/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Launch_Deliverable_ValueInputs */

const en_how_we_work_launch_deliverable_value = /** @type {(inputs: How_We_Work_Launch_Deliverable_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation, team guidance and an operating plan.`)
};

const lv_how_we_work_launch_deliverable_value = /** @type {(inputs: How_We_Work_Launch_Deliverable_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentācija, norādes komandai un darbības plāns.`)
};

/**
* | output |
* | --- |
* | "Documentation, team guidance and an operating plan." |
*
* @param {How_We_Work_Launch_Deliverable_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_launch_deliverable_value = /** @type {((inputs?: How_We_Work_Launch_Deliverable_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Launch_Deliverable_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_launch_deliverable_value(inputs)
	return en_how_we_work_launch_deliverable_value(inputs)
});